import Swiper from 'swiper/swiper-bundle';

const DESKTOP_WIDTH = 1023;

class SwiperComponent {
  containerSelector;
  options;
  activeClass = 'active-slide';
  destroyOnResizeClass;
  container;
  instance;

  init(containerSelector, options = {}, destroyOnResizeClass = null) {
    this.containerSelector = containerSelector;
    this.options = {
      ...options,
      on: {
        slideChange: () => this.updateActiveClass(),
      }
    };
    this.activeClass = 'active-slide';
    this.destroyOnResizeClass = destroyOnResizeClass;
    this.container = document.querySelector(this.containerSelector);
    this.instance = null;

    if (!this.container) {
      return;
    }

    this.handleWindowResize = this.handleWindowResize.bind(this);
    window.addEventListener('resize', this.handleWindowResize);

    this.instance = new Swiper(this.container, this.options);
    this.updateActiveClass();
    this.handleWindowResize();
  }

  destroy() {
    if (this.instance) {
      this.instance.destroy();
      this.instance = null;
    }
  }

  handleWindowResize() {
    const screenWidth = window.innerWidth;
    if (this.destroyOnResizeClass && this.container.classList.contains(this.destroyOnResizeClass) && screenWidth > DESKTOP_WIDTH) {
      this.destroy();
    } else {
      this.init();
    }
  }

  updateAllowTouchMove() {
    const screenWidth = window.innerWidth;
    if (screenWidth > DESKTOP_WIDTH) {
      this.options.allowTouchMove = false;
    } else {
      this.options.allowTouchMove = true;
    }
  }

  updateActiveClass() {
    if (!this.instance) {
      return;
    }
    const slides = this.container.querySelectorAll('.swiper-slide');
    slides.forEach((slide, index) => {
      if (index === this.instance.realIndex) {
        slide.classList.add(this.activeClass);
      } else {
        slide.classList.remove(this.activeClass);
      }
    });
  }
}

export const goodsSwiper = new SwiperComponent();
